module.exports = __webpack_public_path__ + "static/media/USA.c46a7692.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/USA.jpg
// module id = 989
// module chunks = 0